/*
 * 30-Day Lowest Price (Omnibus / L112-1-1 / UWG §11)
 * v2: + sparkline tooltip
 * Reads variant→SKU map embedded by snippets/lowest-price-30d.liquid,
 * fetches /apps/reco/lowest-price?sku=<sku>&market_name=<name>,
 * renders simplified label "30-Tage-Tief: 39,90 €" under the product price,
 * and a sparkline + min/max tooltip on hover/tap/focus.
 * Hidden silently on any error / missing history.
 */
(function () {
  'use strict';

  var CURRENCY_SYMBOL = {
    EUR: '€',
    CZK: 'Kč',
    DKK: 'kr',
    CHF: 'CHF'
  };

  var SVG_NS = 'http://www.w3.org/2000/svg';

  // Single canonical formatter — reused for inline value AND tooltip min/max.
  // EUR/CZK/DKK suffix format ("39,90 €") — European customer expectation.
  function formatPrice(value, currency) {
    var num = Number(value);
    if (!isFinite(num)) return '';
    var formatted;
    try {
      formatted = num.toLocaleString(navigator.language || 'de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      formatted = num.toFixed(2);
    }
    var symbol = CURRENCY_SYMBOL[currency] || currency || '';
    return formatted + ' ' + symbol;
  }

  // Canonical Brewout variant-id extractor.
  // Mirrors snippets/product-grinder-attributes.liquid:322-349 exactly.
  function extractVariantId(event) {
    if (event.currentVariant && event.currentVariant.id) {
      return event.currentVariant.id;
    }
    if (event.detail) {
      if (event.detail.variant && event.detail.variant.id) {
        return event.detail.variant.id;
      }
      if (event.detail.currentVariant && event.detail.currentVariant.id) {
        return event.detail.currentVariant.id;
      }
      if (typeof event.detail.id === 'number' || typeof event.detail.id === 'string') {
        return event.detail.id;
      }
    }
    return null;
  }

  // ---- Sparkline rendering ----

  function clearSvg(svg) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
  }

  function renderSparkline(svg, history, currency) {
    clearSvg(svg);
    if (!history || !history.length) return false;

    var prices = history.map(function (h) { return Number(h.price); }).filter(isFinite);
    if (!prices.length) return false;

    var minP = Math.min.apply(null, prices);
    var maxP = Math.max.apply(null, prices);
    var n = prices.length;

    // Single point: no line, just a centred dot.
    if (n === 1) {
      var dot = document.createElementNS(SVG_NS, 'circle');
      dot.setAttribute('cx', '60');
      dot.setAttribute('cy', '20');
      dot.setAttribute('r', '2');
      dot.setAttribute('fill', 'var(--secondary-color, #555)');
      svg.appendChild(dot);
      return true;
    }

    var points = [];
    for (var i = 0; i < n; i++) {
      var x = (i / (n - 1)) * 120;
      var y;
      if (maxP === minP) {
        y = 20; // horizontal midline
      } else {
        y = 4 + (1 - (prices[i] - minP) / (maxP - minP)) * 32;
      }
      points.push({ x: x, y: y });
    }

    // 2-point case: dots only (per spec — no path stroke).
    if (n === 2) {
      points.forEach(function (p, idx) {
        var c = document.createElementNS(SVG_NS, 'circle');
        c.setAttribute('cx', String(p.x));
        c.setAttribute('cy', String(p.y));
        c.setAttribute('r', idx === n - 1 ? '2' : '1.5');
        c.setAttribute('fill', 'var(--secondary-color, #555)');
        svg.appendChild(c);
      });
      return true;
    }

    // 3+ points: full path + dot on latest.
    var d = 'M ' + points.map(function (p) {
      return p.x.toFixed(2) + ',' + p.y.toFixed(2);
    }).join(' L ');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    path.setAttribute('stroke', 'var(--secondary-color, #555)');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);

    var lastDot = document.createElementNS(SVG_NS, 'circle');
    var last = points[points.length - 1];
    lastDot.setAttribute('cx', String(last.x));
    lastDot.setAttribute('cy', String(last.y));
    lastDot.setAttribute('r', '2');
    lastDot.setAttribute('fill', 'var(--secondary-color, #555)');
    svg.appendChild(lastDot);

    return true;
  }

  function init() {
    // The snippet is now rendered DIRECTLY inside product-price-single's
    // <span class="after-price"> — see snippets/lowest-price-30d.liquid v2.2.
    // JS only fetches data, sets text, manages tooltip + variant change.
    // No DOM reparenting at runtime.
    var container = document.querySelector('.lowest-30d-price');
    if (!container) return;

    var marketName = container.getAttribute('data-market-name');
    if (!marketName) return;

    var labelEl = container.querySelector('.lowest-30d-price__label');
    var valueEl = container.querySelector('.lowest-30d-price__value');
    var mapEl = container.querySelector('script[type="application/json"][data-variant-sku-map]');
    var tooltipEl = container.querySelector('[data-sparkline-tooltip]');
    var sparklineSvg = tooltipEl ? tooltipEl.querySelector('.lowest-30d-price__sparkline') : null;
    var minLabelEl = tooltipEl ? tooltipEl.querySelector('.lowest-30d-price__sparkline-min') : null;
    var maxLabelEl = tooltipEl ? tooltipEl.querySelector('.lowest-30d-price__sparkline-max') : null;
    var inlineHost = null; // unused — kept as null for old code paths
    var separatorEl = null;

    var template30 = labelEl ? labelEl.getAttribute('data-template-30') || '' : '';
    var templateN = labelEl ? labelEl.getAttribute('data-template-n') || '' : '';
    var template1 = labelEl ? labelEl.getAttribute('data-template-1') || '' : '';

    var variantSkuMap = {};
    if (mapEl) {
      try {
        variantSkuMap = JSON.parse(mapEl.textContent || '{}') || {};
      } catch (e) {
        container.classList.add('is-hidden');
        return;
      }
    }

    function lookupSku(variantId) {
      if (variantId == null) return null;
      var key = String(variantId);
      var sku = variantSkuMap[key];
      return sku || null;
    }

    function hide() {
      container.classList.remove('is-ready');
      hideTooltip();
    }

    function show() {
      container.classList.add('is-ready');
    }

    // ---- Tooltip state ----

    var hasTooltipData = false;

    function setTooltipAria(visible) {
      if (!tooltipEl) return;
      tooltipEl.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function hideTooltip() {
      if (!tooltipEl) return;
      tooltipEl.classList.remove('is-visible');
      tooltipEl.classList.remove('is-focus-visible');
      tooltipEl.classList.remove('is-tap-active');
      setTooltipAria(false);
    }

    function renderTooltip(history, currency) {
      if (!tooltipEl || !sparklineSvg) return;
      // If a previous variant had tooltip data and we're now empty,
      // ensure any visible tooltip is dismissed (variant-switch edge case).
      hideTooltip();
      hasTooltipData = false;
      clearSvg(sparklineSvg);
      if (minLabelEl) minLabelEl.textContent = '';
      if (maxLabelEl) maxLabelEl.textContent = '';

      if (!history || !history.length) return;

      var prices = history.map(function (h) { return Number(h.price); }).filter(isFinite);
      if (!prices.length) return;

      var minP = Math.min.apply(null, prices);
      var maxP = Math.max.apply(null, prices);

      var rendered = renderSparkline(sparklineSvg, history, currency);
      if (!rendered) return;

      if (minLabelEl) {
        minLabelEl.textContent = 'min ' + formatPrice(minP, currency);
      }
      if (maxLabelEl) {
        // For single price (min === max), only show one number to avoid duplication.
        if (minP === maxP) {
          maxLabelEl.textContent = '';
        } else {
          maxLabelEl.textContent = 'max ' + formatPrice(maxP, currency);
        }
      }
      hasTooltipData = true;
    }

    var inflight = null; // AbortController

    function fetchAndRender(sku) {
      if (!sku) {
        hide();
        return;
      }

      if (inflight) {
        try { inflight.abort(); } catch (e) { /* noop */ }
      }
      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      inflight = controller;

      var url = '/apps/reco/lowest-price'
        + '?sku=' + encodeURIComponent(sku)
        + '&market_name=' + encodeURIComponent(marketName);

      var fetchOpts = { credentials: 'same-origin' };
      if (controller) fetchOpts.signal = controller.signal;

      fetch(url, fetchOpts)
        .then(function (res) {
          if (!res.ok) throw new Error('http ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (!data || data.lowest_30d == null) {
            hide();
            return;
          }
          var days = Number(data.days_observed);
          if (!isFinite(days) || days <= 0) {
            hide();
            return;
          }

          var label;
          // Heuristic: treat 50% data density (>= 15 of 30 days) as
          // "established product" → show full-window label. Sync gaps on
          // mature products shouldn't visually downgrade the caption.
          // Genuinely new products (< 15 days observed) still show the
          // actual count. Backend fix (B) replaces this with a real
          // product-age check.
          if (data.is_full_window || days >= 15) {
            label = template30;
          } else if (days >= 2) {
            label = templateN.replace('{{days}}', String(days));
          } else {
            label = template1;
          }
          if (!label) {
            hide();
            return;
          }

          if (labelEl) labelEl.textContent = label + ' ';
          if (valueEl) valueEl.textContent = formatPrice(data.lowest_30d, data.currency);

          // v2: tooltip rendering on each variant change.
          renderTooltip(data.history || [], data.currency);

          show();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          hide();
        });
    }

    // ---- Tooltip event wiring ----
    // Hover-capable devices: mouseenter/mouseleave with 1.5s CSS delay.
    // Touch devices: tap toggles, outside tap closes.
    // Keyboard: focus shows with 0.3s delay, blur hides, Escape closes + refocuses.

    var supportsHover = false;
    try {
      supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    } catch (e) {
      supportsHover = false;
    }

    if (tooltipEl) {
      if (supportsHover) {
        // WCAG 2.1 SC 1.4.13: user must be able to move cursor from trigger
        // INTO the tooltip without losing visibility. Tooltip is positioned
        // absolutely outside the container's bounding box, so a naive
        // mouseleave handler would hide it the moment the cursor crosses
        // the gap. Pattern: shared timed hide that's cancelled if mouse
        // re-enters either trigger OR tooltip within the grace period.
        var hideTimer = null;
        function showTooltip() {
          if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
          if (!hasTooltipData) return;
          tooltipEl.classList.add('is-visible');
          setTooltipAria(true);
        }
        function scheduleHide() {
          if (hideTimer) clearTimeout(hideTimer);
          hideTimer = setTimeout(function () {
            tooltipEl.classList.remove('is-visible');
            setTooltipAria(false);
            hideTimer = null;
          }, 200);
        }
        container.addEventListener('mouseenter', showTooltip, { passive: true });
        container.addEventListener('mouseleave', scheduleHide, { passive: true });
        tooltipEl.addEventListener('mouseenter', showTooltip, { passive: true });
        tooltipEl.addEventListener('mouseleave', scheduleHide, { passive: true });
        // Allow tooltip to receive pointer events so its own mouseenter fires.
        tooltipEl.style.pointerEvents = 'auto';
      } else {
        container.addEventListener('click', function (ev) {
          if (!hasTooltipData) return;
          // Don't fight focus/blur — toggle only the tap class.
          var isOn = tooltipEl.classList.contains('is-tap-active');
          if (isOn) {
            tooltipEl.classList.remove('is-tap-active');
            setTooltipAria(false);
          } else {
            tooltipEl.classList.add('is-tap-active');
            setTooltipAria(true);
          }
        });

        document.addEventListener('click', function (ev) {
          if (!tooltipEl.classList.contains('is-tap-active')) return;
          if (container.contains(ev.target)) return;
          tooltipEl.classList.remove('is-tap-active');
          setTooltipAria(false);
        }, { passive: true });
      }

      // Keyboard accessibility (all devices).
      container.addEventListener('focus', function () {
        if (!hasTooltipData) return;
        tooltipEl.classList.add('is-focus-visible');
        setTooltipAria(true);
      });

      container.addEventListener('blur', function () {
        tooltipEl.classList.remove('is-focus-visible');
        // Only flip aria-hidden off if no other visibility class is present.
        if (
          !tooltipEl.classList.contains('is-visible') &&
          !tooltipEl.classList.contains('is-tap-active')
        ) {
          setTooltipAria(false);
        }
      });

      container.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' || ev.keyCode === 27) {
          hideTooltip();
          try { container.focus(); } catch (e) { /* noop */ }
        }
      });
    }

    // ---- Initial fetch ----
    var initialVariantId = container.getAttribute('data-initial-variant-id');
    var initialSku = lookupSku(initialVariantId);
    fetchAndRender(initialSku);

    // ---- Variant-change listening (canonical Brewout pattern) ----
    function handleVariantChangeEvent(event) {
      var variantId = extractVariantId(event);
      if (variantId == null) return;
      var sku = lookupSku(variantId);
      fetchAndRender(sku);
    }

    var eventNames = ['variant:change', 'variant:changed', 'variantChange', 't4s:variant:change'];
    eventNames.forEach(function (eventName) {
      document.addEventListener(eventName, handleVariantChangeEvent);
    });

    var productForm = document.querySelector('form[action*="/cart/add"]');
    var hiddenVariantInput = document.querySelector('input[name="id"][type="hidden"]');

    if (productForm) {
      var allSelects = productForm.querySelectorAll('select');
      allSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          setTimeout(function () {
            if (hiddenVariantInput) {
              var newId = hiddenVariantInput.value;
              var sku = lookupSku(newId);
              fetchAndRender(sku);
            }
          }, 50);
        });
      });
    }

    var variantSwatches = document.querySelectorAll(
      '.t4s-pr-swatch__item, .t4s-prs__item, [data-variant-id], .t4s-product-swatch__item'
    );
    variantSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        setTimeout(function () {
          if (hiddenVariantInput) {
            var newId = hiddenVariantInput.value;
            var sku = lookupSku(newId);
            fetchAndRender(sku);
          }
        }, 100);
      });
    });

    var variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
    variantSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var sku = lookupSku(this.value);
        fetchAndRender(sku);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
